import { useState, useEffect } from "react";

export default function AIProcessing() {
  const [etapa, setEtapa] = useState(0);
  const etapas = ["Lendo recomendação...", "Identificando cultura...", "Definindo prioridade...", "Estruturando tarefa...", "✅ Quase pronto!"];
  useEffect(() => {
    if (etapa < etapas.length - 1) { const t = setTimeout(() => setEtapa(e => e + 1), 600); return () => clearTimeout(t); }
  }, [etapa, etapas.length]);
  return (
    <div className="mt-3 p-3 bg-green-50 dark:bg-green-900/20 border border-green-100 dark:border-green-800 rounded-xl">
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
        <p className="text-sm text-green-700 dark:text-green-400 font-medium">{etapas[etapa]}</p>
      </div>
      <div className="mt-2 h-1 bg-green-100 dark:bg-green-800 rounded-full overflow-hidden">
        <div className="h-full bg-green-500 rounded-full transition-all duration-500" style={{ width: `${((etapa + 1) / etapas.length) * 100}%` }} />
      </div>
    </div>
  );
}
